import { computed } from "vue";
import { useModalStore } from "#/store/modals";

export const useModal = <T>(modalName: string) => {
	const store = useModalStore();

	const open = (context?: T) => store.open(modalName, context);
	const close = () => store.close(modalName);

	const modal = store.state(modalName);
	const visible = computed({
		get: () => modal.value.visible,
		set: (value: boolean) => (value && open()) || close(),
	});
	const context = computed<T>(() => modal.value.context as T);

	return { visible, context, open, close };
};
